<template>
  <div class="support-chat">
    <div>
      <h2>Meus atendimentos</h2>
      <b-table
        ref="table1"
        class="small-b-table"
        :busy="isBusy"
        :items="getMyServices"
        :fields="fields"
      >
        <template v-slot:cell(actions)="data">
          <BaseDialogConfirm
            :ref="`confirmCompleteService${data.item.id}`"
            @confirm="completeService(data.item.id)"
            :message="'Deseja finalizar o atendimento?'"
            :title="'Finalizar atendimento'"
          >
          </BaseDialogConfirm>
          <b-button
            :id="`btn-finalizar-atendimento-${data.item.id}`"
            class="btn-small-icon"
            size="sm"
            variant="green"
            @click="$refs[`confirmCompleteService${data.item.id}`].show()"
          >
            <i class="material-icons">check</i>
            <!-- Finalizar atendimento -->
          </b-button>
          <b-tooltip
            :target="`btn-finalizar-atendimento-${data.item.id}`"
            triggers="hover"
          >
            Finalizar atendimento
          </b-tooltip>
        </template>
        <template v-slot:cell(id)="data">
          <b-link class="link" href="#" @click="openModal(data.item)">
            #{{ data.item.id }}
          </b-link>
        </template>
        <template v-slot:cell(supportAgentId)="data">
          <div :class="getRowStyle(data.item)">
            <UserDropdown
              :userId="data.item.supportAgentId"
              :usersOptions="userDropdownOptions"
              @change="
                (newResponsibleId) =>
                  changeResponsible(data.item.id, newResponsibleId)
              "
            />
          </div>
        </template>
        <template v-slot:cell(name)="data">
          <div v-if="data.item.whatsAppInviteUrl != null">
            <u>
              <a
                class="link"
                :href="data.item.whatsAppInviteUrl"
                target="_blank"
              >
                {{ data.item.name }}
              </a>
            </u>
          </div>
          <div v-else>
            {{ data.item.name }}
          </div>
        </template>
      </b-table>
    </div>

    <div class="mt-2">
      <h2>Atendimentos não iniciados</h2>
      <b-table
        ref="table2"
        class="small-b-table"
        :busy="isBusy"
        :items="getFreeMessages"
        :fields="fields"
      >
        <template v-slot:cell(actions)="data">
          <b-button
            :id="`btn-finalizar-atendimento-${data.item.id}`"
            class="btn-small-icon"
            size="sm"
            variant="green"
            @click="startService(data.item.id)"
          >
            <i class="material-icons">play_arrow</i>
          </b-button>
          <b-tooltip
            :target="`btn-finalizar-atendimento-${data.item.id}`"
            triggers="hover"
          >
            Iniciar atendimento
          </b-tooltip>
        </template>
        <template v-slot:cell(id)="data">
          <b-link class="link" href="#" @click="openModal(data.item)">
            #{{ data.item.id }}
          </b-link>
        </template>
        <template v-slot:cell(supportAgentId)="data">
          <div :class="getRowStyle(data.item)">
            <UserDropdown
              :userId="data.item.supportAgentId"
              :usersOptions="userDropdownOptions"
              @change="
                (newResponsibleId) =>
                  changeResponsible(data.item.id, newResponsibleId)
              "
            />
          </div>
        </template>
        <template v-slot:cell(name)="data">
          <div v-if="data.item.whatsAppInviteUrl != null">
            <u>
              <a
                class="link"
                :href="data.item.whatsAppInviteUrl"
                target="_blank"
              >
                {{ data.item.name }}
              </a>
            </u>
          </div>
          <div v-else>
            {{ data.item.name }}
          </div>
        </template>
      </b-table>
    </div>

    <div v-if="isSupportAdmin" class="mt-2">
      <h2>Atendimentos em andamento (administração)</h2>
      <b-table
        ref="table3"
        class="small-b-table"
        :busy="isBusy"
        :items="listAdminMessages"
        :fields="fields"
      >
        <template v-slot:cell(actions)="data">
          <BaseDialogConfirm
            :ref="`confirmCompleteService${data.item.id}`"
            @confirm="completeService(data.item.id)"
            :message="'Deseja finalizar o atendimento?'"
            :title="'Finalizar atendimento'"
          >
          </BaseDialogConfirm>
          <b-button
            :id="`btn-finalizar-atendimento-${data.item.id}`"
            class="btn-small-icon"
            size="sm"
            variant="green"
            @click="$refs[`confirmCompleteService${data.item.id}`].show()"
          >
            <i class="material-icons">check</i>
            <!-- Finalizar atendimento -->
          </b-button>
          <b-tooltip
            :target="`btn-finalizar-atendimento-${data.item.id}`"
            triggers="hover"
          >
            Finalizar atendimento
          </b-tooltip>
        </template>
        <template v-slot:cell(id)="data">
          <b-link class="link" href="#" @click="openModal(data.item)">
            #{{ data.item.id }}
          </b-link>
        </template>
        <template v-slot:cell(supportAgentId)="data">
          <div :class="getRowStyle(data.item)">
            <UserDropdown
              :userId="data.item.supportAgentId"
              :usersOptions="userDropdownOptions"
              @change="
                (newResponsibleId) =>
                  changeResponsible(data.item.id, newResponsibleId)
              "
            />
          </div>
        </template>
        <template v-slot:cell(name)="data">
          <div v-if="data.item.whatsAppInviteUrl != null">
            <u>
              <a
                class="link"
                :href="data.item.whatsAppInviteUrl"
                target="_blank"
              >
                {{ data.item.name }}
              </a>
            </u>
          </div>
          <div v-else>
            {{ data.item.name }}
          </div>
        </template>
      </b-table>
    </div>

    <b-modal
      ref="modal"
      :title="`${selectedGroupName} (Atendimento #${selectedServiceId})`"
      size="xl"
    >
      <SupportChatTimeline :serviceId="selectedServiceId" />
    </b-modal>
  </div>
</template>
  
<script>
import * as signalR from "@microsoft/signalr";

import { RepositoryFactory } from "@/repositories/RepositoryFactory";
const userRepository = RepositoryFactory.get("user");

export default {
  data() {
    return {
      autoRefresh: null,
      autoRefreshTime: 5000,
      connection: null,
      newMessage: "",
      messages: [],
      fields: [
        {
          key: "actions",
          sortable: false,
          label: "",
          tdClass: (value, key, item) => this.getRowStyle(item),
          thStyle: "width: 100px",
        },
        {
          key: "id",
          sortable: false,
          label: "Id",
          tdClass: (value, key, item) => this.getRowStyle(item),
          thStyle: "width: 100px",
        },
        {
          key: "whoLastInteracted",
          sortable: false,
          label: "Ultima interação",
          tdClass: (value, key, item) => this.getRowStyle(item),
          thStyle: "width: 100px",
        },
        {
          key: "lastInteractionAt",
          sortable: false,
          label: "Data ultima interação",
          tdClass: (value, key, item) => this.getRowStyle(item),
          thStyle: "width: 175px",
          formatter: (value, key, item) => {
            if (value == null) return "";
            let date = new Date(value.split("+", 1));
            return this.formatDatetimePtBr(date);
          },
        },
        {
          key: "timeLastInteraction",
          sortable: false,
          label: "Tempo ultima interação",
          tdClass: (value, key, item) => this.getRowStyle(item),
          thStyle: "width: 175px",
          formatter: (value, key, item) => {
            if (item.lastInteractionAt == null) return "";
            var startTime = new Date(item.lastInteractionAt.split("+", 1));
            var endTime = new Date();
            return this.elapsedTime(startTime, endTime);
          },
        },
        {
          key: "supportAgentId",
          sortable: false,
          label: "Responsável suporte",
          tdClass: (value, key, item) => this.getRowStyle(item),
          thStyle: "width: 200px",
        },
        {
          key: "clientLastInteractedDisplayName",
          sortable: false,
          label: "Cliente ultima interação",
          tdClass: (value, key, item) => this.getRowStyle(item),
          thStyle: "width: 200px",
        },
        {
          key: "name",
          sortable: false,
          label: "Grupo",
          tdClass: (value, key, item) => this.getRowStyle(item),
          thStyle: "width: 300px",
        },
      ],
      isBusy: false,
      userDropdownOptions: [],
      selectedServiceId: null,
      selectedGroupName: null,
    };
  },
  components: {
    BaseDialogConfirm: () =>
      import("@/components_rms/base/BaseDialogConfirm.vue"),
    UserDropdown: () => import("@/components_rms/System/User/UserDropdown.vue"),
    SupportChatTimeline: () =>
      import("@/pagesRms/support/SupportChatTimeline.vue"),
  },
  created: function () {
    this.autoRefresh = setInterval(this.refreshTables, this.autoRefreshTime); // mudar para 5s
  },
  beforeDestroy: function () {
    clearInterval(this.autoRefresh);
  },
  computed: {
    getMyServices() {
      let messages = [];
      let userDisplayName = this.$store.getters.userDisplayname;
      for (let message of this.listAllMessages) {
        if (message.isAgentResponsability(userDisplayName)) {
          messages.push(message);
        }
      }
      return messages;
    },
    getFreeMessages() {
      let messages = [];
      for (let message of this.listAllMessages) {
        if (message.isFreeService()) {
          messages.push(message);
        }
      }
      return messages;
    },
    getServicesFromOthers() {
      let messages = [];
      let userDisplayName = this.$store.getters.userDisplayname;
      for (let message of this.listAllMessages) {
        if (message.isNotAgentResponsability(userDisplayName)) {
          messages.push(message);
        }
      }
      return messages;
    },
    isSupportAdmin() {
      // if (this.$store.getters.isAdministrator) return true;
      if (this.$store.getters.getUserName == "ivan") return true;
      if (this.$store.getters.getUserName == "renan") return true;
      if (this.$store.getters.getUserName == "natan") return true;
      if (this.$store.getters.getUserName == "eloir") return true;
      if (this.$store.getters.getUserName == "borba") return true;
      if (this.$store.getters.getUserName == "mariane.pinter") return true;
      if (this.$store.getters.getUserName == "rafaelly.loth") return true;
      return false;
    },
    listAllMessages() {
      if (!this.messages) return [];
      let allmessages = this.messages;
      return allmessages.sort(
        (a1, a2) =>
          new Date(a1.lastInteractionAt.split("+", 1)) -
          new Date(a2.lastInteractionAt.split("+", 1))
      );
    },
    listAdminMessages() {
      let allmessages = this.getServicesFromOthers;
      return allmessages.sort((a, b) => {
        // if (a.whoLastInteracted !== a.whoLastInteracted) {
        //   return a.whoLastInteracted - a.whoLastInteracted;
        // }
        // return (
        //   new Date(b.lastInteractionAt.split("+", 1)) -
        //   new Date(a.lastInteractionAt.split("+", 1))
        // );

        let sequenceA = this.getSortOrder(a);
        let sequenceB = this.getSortOrder(b);
        if (sequenceA !== sequenceB) {
          return sequenceA - sequenceB;
        }
        return (
          new Date(a.lastInteractionAt.split("+", 1)) -
          new Date(b.lastInteractionAt.split("+", 1))
        );
      });
    },
  },
  methods: {
    async completeService(id) {
      try {
        await this.$apiScheduler.put(`/api/supportChat/complete/${id}`);
      } catch (error) {
        console.log(error);
        if (error.response.status == 401) {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        } else {
          this.isBusy = false;
          callback([]);
        }
      }
    },
    async changeResponsible(serviceId, newResponsibleId) {
      try {
        await this.$apiScheduler.put(
          `/api/supportChat/changeResponsible/${serviceId}/${newResponsibleId}`
        );
      } catch (error) {
        console.log(error);
        if (error.response.status == 401) {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        } else {
          this.isBusy = false;
          callback([]);
        }
      }
    },
    getMessageByName(name) {
      for (let message of this.messages) {
        if (message.name == name) {
          return message;
        }
      }
      return null;
    },
    getSortOrder(item) {
      switch (item.whoLastInteracted.toUpperCase()) {
        case "SUPORTE":
          var startDate = new Date(item.lastInteractionAt.split("+", 1));
          if (this.isElapsedMinutesGreaterThen(startDate, 20)) {
            return 4;
          }
          return 3;
        case "CLIENTE":
          var startDate = new Date(item.lastInteractionAt.split("+", 1));
          if (this.isElapsedMinutesGreaterThen(startDate, 20)) {
            return 1;
          }
          return 2;
      }
    },
    getRowStyle(item) {
      switch (item.whoLastInteracted.toUpperCase()) {
        case "SUPORTE":
          var startDate = new Date(item.lastInteractionAt.split("+", 1));
          if (this.isElapsedMinutesGreaterThen(startDate, 20)) {
            return "cinza";
          }
          return "azul";
        case "CLIENTE":
          var startDate = new Date(item.lastInteractionAt.split("+", 1));
          if (this.isElapsedMinutesGreaterThen(startDate, 20)) {
            return "vermelho";
          }
          return "amarelo";
      }
    },
    async loadUserDropdownOptions() {
      try {
        const response = await userRepository.listRmsDropdownOptions(this);
        this.userDropdownOptions = response;
      } catch (error) {
        console.error("error", error);
        if (error.response.status == 401) {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        }
        console.error("Erro ao carregar usuários:", error);
        this.userDropdownOptions = [
          { value: null, text: "Erro ao carregar usuários" },
        ];
      }
    },
    async listNotCompleted() {
      try {
        const result = await this.$apiScheduler.get("/api/supportChat/list/");
        if (result.status == 200) {
          let notCompletedList = result.data;
          for (let notCompletedMessage of notCompletedList) {
            let message = this.getMessageByName(notCompletedMessage.name);
            if (message == null) {
              this.messages.push(new SupportService(notCompletedMessage));
            }
          }
        }
      } catch (error) {
        console.log(error);
        if (error.response.status == 401) {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        } else {
          this.isBusy = false;
          callback([]);
        }
      }
    },
    openModal(service) {
      this.selectedServiceId = service.id;
      this.selectedGroupName = service.name;
      this.$refs.modal.show();
    },
    async sendMessage() {
      if (this.newMessage.trim() !== "") {
        await this.connection.invoke("SendMessage", "User", this.newMessage);
        this.newMessage = "";
      }
    },
    async startConnection() {
      this.connection = new signalR.HubConnectionBuilder()
        .withUrl(`${this.$store.getters.urlScheduler}/chatHub`, {
          withCredentials: false,
          transport: signalR.HttpTransportType.LongPolling,
          mode: "no-cors", // Usar modo no-cors (limita funcionalidades)
        })
        .withAutomaticReconnect() // Habilita reconexão automática
        .configureLogging(signalR.LogLevel.Information) // Ativar logging de informações
        .build();
      // this.connection.serverTimeoutInMilliseconds = 28800000;

      this.connection.on("ReceiveMessage", (newMessage) => {
        // console.log("ReceiveMessage", newMessage);
        let message = this.getMessageByName(newMessage.name);
        if (message != null) {
          if (newMessage.isComplete) {
            let index = this.messages.indexOf(message);
            if (index >= 0) {
              this.messages.splice(index, 1);
            }
          } else {
            message.setNewMessageInteraction(newMessage);
          }
        } else {
          this.messages.push(new SupportService(newMessage));
        }
      });

      try {
        await this.connection.start();
        console.log("SignalR Connected.");
      } catch (err) {
        console.error("Error while starting SignalR connection: ", err);
        setTimeout(this.startConnection, 5000);
      }

      // Captura o evento de fechamento da conexão
      this.connection.onclose((error) => {
        if (error) {
          console.error("Conexão fechada devido a um erro:", error);
          setTimeout(this.startConnection, 1000);
        } else {
          console.warn("Conexão fechada normalmente.");
        }
      });

      // Captura tentativas de reconexão
      this.connection.onreconnecting((error) => {
        console.warn("Tentando reconectar devido a um erro:", error);
      });

      // Captura o evento de reconexão bem-sucedida
      this.connection.onreconnected(async () => {
        // console.log("Reconexão bem-sucedida.");
        await this.listNotCompleted();
      });
    },
    async startService(id) {
      try {
        await this.$apiScheduler.put(`/api/supportChat/start/${id}`);
      } catch (error) {
        console.log(error);
        if (error.response.status == 401) {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        } else {
          this.isBusy = false;
          callback([]);
        }
      }
    },
    refreshTables() {
      this.$refs.table1.refresh();
      this.$refs.table2.refresh();
      this.$refs.table3.refresh();
    },
  },
  async mounted() {
    this.isBusy = true;
    this.loadUserDropdownOptions();
    await this.startConnection();
    await this.listNotCompleted();
    this.isBusy = false;
  },
};

class SupportService {
  constructor(message) {
    this.id = message.id;
    this.name = message.name;
    this.lastInteractionAt = message.lastInteractionAt;
    this.whoLastInteracted = message.whoLastInteracted;
    this.supportAgentId = message.supportAgentId;
    this.supportAgentDisplayName = message.supportAgentDisplayName;
    this.clientLastInteractedDisplayName =
      message.clientLastInteractedDisplayName;
    this.whatsAppInviteUrl = message.whatsAppInviteUrl;
  }

  isFreeService() {
    return (
      this.supportAgentDisplayName == null || this.supportAgentDisplayName == ""
    );
  }

  isAgentResponsability(userDisplayName) {
    return this.supportAgentDisplayName == userDisplayName;
  }

  isNotAgentResponsability(userDisplayName) {
    return (
      !this.isFreeService() && !this.isAgentResponsability(userDisplayName)
    );
  }

  setNewMessageInteraction(newMessage) {
    this.lastInteractionAt = newMessage.lastInteractionAt;
    this.whoLastInteracted = newMessage.whoLastInteracted;
    this.supportAgentId = newMessage.supportAgentId;
    this.supportAgentDisplayName = newMessage.supportAgentDisplayName;
    this.clientLastInteractedDisplayName =
      newMessage.clientLastInteractedDisplayName;
  }
}
</script>
  
<style>
.support-chat .amarelo {
  background-color: #df9101 !important;
  color: black !important;
}
.support-chat .amarelo .link {
  color: black !important;
}
.support-chat .amarelo .multiselect__tags {
  background-color: #df9101 !important;
}
.support-chat .amarelo .multiselect__single {
  color: black !important;
}

/* .support-chat .azul .multiselect__tags {
} */

.support-chat .cinza {
  background-color: #a0a0a0 !important;
  color: black !important;
}
.support-chat .cinza .link {
  color: black !important;
}
.support-chat .cinza .multiselect__tags {
  background-color: #a0a0a0 !important;
}
.support-chat .cinza .multiselect__single {
  color: black !important;
}

.support-chat .vermelho {
  background-color: #ec5353 !important;
  color: black !important;
}
.support-chat .vermelho .link {
  color: black !important;
}
.support-chat .vermelho .multiselect__tags {
  background-color: #ec5353 !important;
}
.support-chat .vermelho .multiselect__single {
  color: black !important;
}
</style>